import { all } from 'redux-saga/effects'

export function* userSaga() {
  yield all([])
}
